import {
  Box,
  Button,
  chakra,
  Flex,
  shouldForwardProp,
  Text
} from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { COMMON_WEB_PATH } from '../../constant';
import useCheckLogin from '../../hook/useCheckLogin';
import {
  ALREADY_SHOW_LOSS_POINT_MODAL_STATE,
  RESET_LOSS_POINT_MODAL_STATE
} from '../../redux/action/member/memberAction';
import CommonModal from '../Common/CommonModal';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

//輸分已達到，不可充值彈窗
//輸分已達到，不可充值彈窗
//輸分已達到，不可充值彈窗
const LossPointModal = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const [showModal, setShowModal] = useState(false);

  const { isLogin } = useCheckLogin();

  const dispatch = useDispatch();
  const isLossPointState = useSelector((state) => state.isLossPointState);
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  //玩家狀態，5為凍結輸分
  const { status } = isMemberInfo || {};

  const handleConfirm = () => {
    dispatch(ALREADY_SHOW_LOSS_POINT_MODAL_STATE());
    setShowModal(false);
  };

  useEffect(() => {
    if (isLogin) {
      //登入後才會判斷
      if (status == 5) {
        //當狀態為5(凍結輸分)時，且初始輸分MODAL為true時，彈出提示框
        if (isLossPointState) {
          setShowModal(true);
        }
      } else {
        //用來重置狀態
        //因為有可能後台會將機台的狀態改為其他狀態
        dispatch(RESET_LOSS_POINT_MODAL_STATE());
      }
    }
  }, [isLogin, status, isLossPointState]);

  return (
    showModal && (
      <CommonModal onConfirm={handleConfirm}>
        <Box fontSize="32px" color="white" textAlign="center" mb={2}>
          {i18n_common('lossPointModalTitle')}
        </Box>
        <Box fontSize="24px" color="white" textAlign="center" mb={2}>
          {i18n_common('lossPointModalContent')}
        </Box>

        <Flex gap={4} mb={4} justifyContent="space-between" alignItems="center">
          <Button
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`,
              bgSize: 'contain',
              bgRepeat: 'no-repeat',
              bgPosition: 'center',
              background: 'transparent',
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`
              },
              h: '65px'
            }}
            onClick={handleConfirm}
            py="20px"
            type="submit"
            w="130px"
          >
            <Text mb="5px" color="#0C5426" fontWeight={900} fontSize="23px">
              {i18n_common('confirm')}
            </Text>
          </Button>
        </Flex>
      </CommonModal>
    )
  );
};

export default LossPointModal;
